export function simplifyCycle(cycle: string): string {
  if (!cycle) return '';
  if (cycle.length === 0) return '';

  return cycle.split('-').slice(1).join('-');
}
